/* eslint-env _castle */
import React from 'react';
import appconfig from 'config/appconfig';
import environment from 'lib/environment';
import {cssTransition, toast} from "react-toastify";

// Callback function to return the div for modal content placement
export const getModalParent = () => document.querySelector('.container-fluid');


// Function to answer the social account name to display in the UI.
// This conversion function is necessary because we can't use the actual account names
//   in appconfig.socialAcounts as those are aligned with API name/value pairs.
export const getSocialAccountName = (socialAccount) => {
  let socialAccountName = '';

  switch (socialAccount) {
    case appconfig.socialAccounts.GOOGLE :
      socialAccountName = appconfig.socialAccountNames.GOOGLE;
      break;
    case appconfig.socialAccounts.FACEBOOK :
      socialAccountName = appconfig.socialAccountNames.FACEBOOK;
      break;
    case appconfig.socialAccounts.LINKEDIN :
      socialAccountName = appconfig.socialAccountNames.LINKEDIN;
      break;
    case appconfig.socialAccounts.MICROSOFT :
      socialAccountName = appconfig.socialAccountNames.MICROSOFT;
      break;
    case appconfig.socialAccounts.APPLE :
      socialAccountName = appconfig.socialAccountNames.APPLE;
      break;
    case appconfig.socialAccounts.LASTPASS :
      socialAccountName = appconfig.socialAccountNames.LASTPASS;
      break;
    default:
      socialAccountName = '';
  }

  return socialAccountName;
};


// Function to answer the support link URL - based on the SCIM "supportExperience" value.
export const getSupportExperienceUrls = (supportExperience) => {
  const urls = {
    supportUrl: '',
    faqUrl: '',
  };
  if (supportExperience === appconfig.supportExperiences.DEFAULT) {
    urls.supportUrl = environment.get().support_url;
    urls.faqUrl = environment.get().faq_url;
  } else if (supportExperience === appconfig.supportExperiences.JIVE_ONLY) {
    urls.supportUrl = environment.get().jive_support_url;
    urls.faqUrl = environment.get().jive_faq_url;
  }
  return urls;
};

// Function to return the password recovery URL.
export const getForgotPasswordUrl = () => {
  return `${environment.get().login_service_url}/?service=${encodeURIComponent(location.href)}`;
};

// Function to return query string values from a URL's location.search as an object.
export const getQueryStringParams = (searchStr) => {
  const queryValues = {};
  if (searchStr) {
    const searchString = searchStr.charAt(0) === '?' ? searchStr.substring(1) : searchStr;
    const paramArray = searchString.split('&');
    paramArray.forEach((param) => {
      const keyValuePair = param.split('=');
      if (keyValuePair.length === 2) {
        let val = keyValuePair[1].toLowerCase() === 'true' ? true : keyValuePair[1];
        val = val === 'false' ? false : val;
        queryValues[keyValuePair[0]] = val;
      }
    });
  }
  return queryValues;
};

// Function to scroll the page to the top.
export const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

// Function to display toastr messages (react-toastify) in core-view.js - https://www.npmjs.com/package/react-toastify
export const showToastrMessage = (toastrType, toastrMessage) => {
  const messageType = toastrType.trim().toLowerCase();
  if (messageType === 'success' || messageType === 'info' || messageType === 'error') {
    toast[messageType](
      toastrMessage,
      {
        autoClose: messageType === 'error' ? 12000 : 6000,
        draggable: false,
        position: toast.POSITION.TOP_RIGHT,
        hideProgressBar: true,
        newestOnTop: true,
        closeButton: true,
        transition: cssTransition({
          enter: 'fadeIn',
          exit: 'fadeOut',
          duration: 350,
        }),
        className: `toastifyToast ${messageType}`,
      }
    );
  }
  return true;
};

// eslint-disable-next-line react/prop-types
export const ToastifyCloseButton = ({closeToast}) => (
  <button onClick={closeToast}>
    <i
      className="togo-icon togo-icon-closes"
     />
  </button>
);

// Stop event
export const stopEvent = (e) => {
  if (typeof e !== 'undefined') {
    e.stopPropagation();
    e.preventDefault();
  }
};

export const isUserInvitationPage = () => {
  return window.location.pathname.toLowerCase().indexOf(appconfig.routes.userInvitation()) > -1;
};

export const isInvitationAcceptancePage = () => {
  return window.location.pathname.toLowerCase().indexOf(appconfig.routes.acceptInvitation()) > -1;
};
